/* eslint-disable no-shadow */
export const EndecaSearchPagesTypes = {
  search: 'search',
  catalog: 'browse',
  all: 'all',
};
